import React, { useState } from 'react';
import { ElevatedButton, IconButton } from '@producer/ui-kit';

import { selectFiles } from '../../../core/services/file.service';

type IconUploadButtonProps = {
  text?: never;
  icon: React.ReactNode;
  variant: 'icon';
};

type TextUploadButtonProps = {
  text: string;
  icon?: React.ReactNode;
  variant?: 'default';
};

type UploadButtonProps = (IconUploadButtonProps | TextUploadButtonProps) & {
  accept?: string;
  multiple?: boolean;
  onUploadFileValue: (files: File[]) => Promise<void>;
};

export const UploadButton: React.FC<UploadButtonProps> = ({
  text,
  onUploadFileValue,
  icon,
  accept = '*',
  multiple,
  variant = 'default',
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const openFileNavigator = async () => {
    if (isLoading) {
      return;
    }

    const files = await selectFiles({
      multiple,
      accept,
    });

    setIsLoading(true);

    if (!files || files.length === 0) {
      setIsLoading(false);
      return;
    }

    await onUploadFileValue(files);

    setIsLoading(false);
  };

  if (variant === 'icon') {
    return <IconButton icon={icon} onClick={openFileNavigator} />;
  }

  return (
    <ElevatedButton text={text!} onClick={openFileNavigator} icon={icon} isLoading={isLoading} />
  );
};
